import React, { useEffect, useRef } from "react";
import "./addpage.scss";
import OverlayLoading from "../../../common/OverlayLoader/Overlayloader";
import useAddPageUtils from "./addpageUtils";
import { TitleHeader } from "../../../components";
import { useSelector } from "react-redux";
import { Autocomplete, TextField } from "@mui/material";

const AddPage = () => {
  const { langauges } = useSelector((state) => state.userAuth);
  const breadcrumbs = [
    { label: "Pages", link: "" },
    { label: "Add Page", link: "" },
  ];

  const {
    formData,
    loading,
    handleFormChange,
    submitForm,
    formErrors,
    setFormData,
    navigate
  } = useAddPageUtils();

  const editorRef = useRef(null); // Store CKEditor instance

  useEffect(() => {
    if (!editorRef.current) {
      const editorElement = document.querySelector("#editor");

      if (editorElement) {
        window.ClassicEditor.create(editorElement)
          .then((editor) => {
            editorRef.current = editor; // Store instance

            // Set initial value
            editor.setData(formData?.description || "");

            // Update formData when content changes
            editor.model.document.on("change:data", () => {
              handleFormChange({
                target: {
                  name: "description",
                  value: editor.getData(),
                },
              });
            });
          })
          .catch((error) =>
            console.error("CKEditor initialization error:", error)
          );
      }
    }
  }, []);

  // Ensure CKEditor updates when formData changes
  useEffect(() => {
    if (
      editorRef.current &&
      editorRef.current.getData() !== formData?.description
    ) {
      editorRef.current.setData(formData?.description || "");
    }
  }, [formData?.description]);

  return (
    <>
      <TitleHeader heading="Add New Page" breadcrumbs={breadcrumbs} />
      <div className="form-all-grid">
        <div className="form-data-main">
          <div className="form-all-grid">
            <div className="input-main-data">
              <label htmlFor="">Langauges</label>
              <Autocomplete
                fullWidth
                className="automcomplete_select_info"
                autoComplete={false}
                id="free-solo-demo"
                options={langauges}
                getOptionLabel={(option) => option?.title}
                renderInput={(params) => (
                  <TextField {...params} placeholder="Select Status" />
                )}
                value={
                  (langauges &&
                    langauges.find(
                      (type) => type.id == formData?.language_id
                    )) ||
                  null
                }
                onChange={(e, value) => {
                  setFormData((prev) => ({
                    ...prev,
                    language_id: value ? value.id : "",
                  }));
                }}
              />
            </div>
            <div className="input-main-data"></div>
            <div className="input-main-data"></div>
          </div>
        </div>

        <form onSubmit={submitForm}>
          <OverlayLoading isLoading={loading}>
            <div className="page-card-bg data-page-big-height">
              <div className="row form-all-grid mb-4">
                <div className="col-md-6 input-main-data col-xl-6">
                  <label>Title</label>
                  <input
                    type="text"
                    name="title"
                    onChange={handleFormChange}
                    value={formData?.title}
                  />
                  {formErrors?.title && (
                    <div className="error_message">{formErrors?.title}</div>
                  )}
                </div>

                <div className="col-md-6  input-main-data col-xl-6">
                  <label htmlFor="">Status</label>
                  <Autocomplete
                    fullWidth
                    className="automcomplete_select_info"
                    autoComplete={false}
                    id="status"
                    options={[
                      { id: "Active", title: "Active" },
                      { id: "Deactive", title: "Deactive" },
                    ]}
                    getOptionLabel={(option) => option?.title}
                    renderInput={(params) => (
                      <TextField {...params} placeholder="Select Status" />
                    )}
                    value={
                      [
                        { id: "Active", title: "Active" },
                        { id: "Deactive", title: "Deactive" },
                      ].find((type) => type.id == formData?.status) || null
                    }
                    onChange={(e, value) => {
                      handleFormChange({
                        target: {
                          name: "status",
                          value: value.id,
                        },
                      });
                    }}
                  />
                </div>
              </div>

              <div className="form-all-grid">
                <div className="input-main-data">
                  <label>Description</label>
                  <textarea id="editor"></textarea>{" "}
                  {/* CKEditor replaces this */}
                  {formErrors?.description && (
                    <div className="error_message">
                      {formErrors?.description}
                    </div>
                  )}
                </div>
              </div>

              <div className="btn-form-send">
                 <button type="button" class="common-button cancel-btn" onClick={() => navigate(`/pages`)}>Cancel</button>
                <button className="common-button" disabled={loading}>
                  Submit
                </button>
              </div>
            </div>
          </OverlayLoading>
        </form>
      </div>
    </>
  );
};

export default AddPage;
